import axios from "axios";
import { API_ROUTES } from "../constants";
import { useState } from "react";
import { LoadingSpinner } from "./common/ui/LoadingSpinner";
import DataModal from "./common/ui/DataModal";

const ImageTableIcons = ({ imageId, tableId }) => {
  const [imageUrls, setImageUrls] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [imageModelOpen, setImageModalOpen] = useState(false);
  const [tableModelOpen, setTableModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const hasImage = imageId?.length > 0;
  const hasTable = tableId?.length > 0;

  const IMAGE_API_URL = `${process.env.REACT_APP_API_URL}${API_ROUTES.IMAGEURL}`;

  const TABLE_API_URL = `${process.env.REACT_APP_API_URL}${API_ROUTES.TABLEDATA}`;

  const handleSendImages = async () => {
    setImageModalOpen(true);
    setLoading(true);
    try {
      const response = await axios.post(IMAGE_API_URL, {
        imageIds: imageId,
      });
      setImageUrls(response.data.response);
    } catch (error) {
      console.error("error sending image id", error);
    } finally {
      setLoading(false);
    }
  };
  const handleTableData = async () => {
    setTableModalOpen(true);
    setLoading(true);
    try {
      const response = await axios.post(TABLE_API_URL, {
        tableId: tableId,
      });
      setTableData(response.data.response);
    } catch (error) {
      console.error("error sending table id", error);
    } finally {
      setLoading(false);
    }
  };

  const openImageModal = () => {
    setImageModalOpen(true);
  };

  const openTableModal = () => {
    setTableModalOpen(true);
  };

  const handleImageModalClose = () => {
    setImageModalOpen(false);
  };
  const handleTableModalClose = () => {
    setTableModalOpen(false);
  };

  if (!hasImage && !hasTable) return null;

  return (
    <>
      <div className="flex gap-2">
        {hasImage && (
          <button
            className="px-2 border rounded transition h-7 hover:bg-gray-100"
            title="Image available"
            onClick={() => {
              handleSendImages();
              openImageModal();
            }}
          >
            <i className="bi bi-image text-gray-700 text-base"></i>
          </button>
        )}
        {hasTable && (
          <button
            className="px-2 border rounded transition h-7 hover:bg-gray-100"
            title="Table available"
            onClick={() => {
              handleTableData();
              openTableModal();
            }}
          >
            <i className="bi bi-table text-gray-700 text-base"></i>
          </button>
        )}
      </div>
      {imageModelOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-5xl mx-4 text-black dark:text-white transition-colors">
            <div className="p-6">
              <div className="flex justify-between">
                <h2 className="text-lg font-semibold mb-2">Images</h2>
                <button
                  onClick={handleImageModalClose}
                  className="text-gray-600 dark:text-gray-300 hover:text-red-600 dark:hover:text-red-400 text-xl font-bold"
                >
                  &times;
                </button>
              </div>
              <div className="w-full h-[450px] overflow-y-auto p-4">
                {loading ? (
                  <LoadingSpinner className="h-12 w-12 mx-auto" />
                ) : (
                  <div className="flex flex-col items-center gap-4">
                    {imageUrls.map((url, index) => (
                      <a
                        key={index}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full max-w-4xl border border-gray-300 dark:border-gray-600 rounded-lg shadow transition-colors"
                      >
                        <img
                          src={url}
                          alt="pragya-image"
                          className="w-full max-h-[400px] object-contain bg-white dark:bg-gray-700"
                        />
                      </a>
                    ))}
                  </div>
                )}
              </div>
              <div className="mt-4 flex justify-end">
                <button
                  onClick={handleImageModalClose}
                  className="bg-gray-600 dark:bg-gray-700 text-white px-4 py-2 rounded hover:bg-gray-700 dark:hover:bg-gray-600 transition"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {tableModelOpen && (
        <DataModal
          isOpen={tableModelOpen}
          onClose={handleTableModalClose}
          data={tableData}
        />
      )}
    </>
  );
};

export default ImageTableIcons;
